// extracted by mini-css-extract-plugin
export var menuIcon = "_qi-0";
export var menuIconInline = "_qi-1";